import { createFileRoute } from '@tanstack/react-router'
import { requireSection } from '../../../features/settings/guards'
import { ServiceSection } from '../../../features/settings/service-section'

export const Route = createFileRoute('/_app/settings/service')({
  staticData: { crumb: 'settingsSection' },
  beforeLoad: ({ context }) => requireSection(context.session, 'service'),
  component: ServiceSection,
})
